import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de231c46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "1. Skapa en resplan:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "2. Hitta lämpliga tåg:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "3. Räkna resdagarna:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/guider/tagluffning-for-nyborjare" }, "Tågluffnig för nybörjare", -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomCard from "../../generics/CustomCard.vue";
import CustomPic from "../../generics/CustomPic.vue";
import TextImgContentBlock from "../../blocks/TextImgContentBlock.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'TicketChoiceGuide',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).TicketChoiceGuide), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Välj interrailkort",
      backgroundImageClass: "background-champs-elysees"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "Vi förstår vikten av att skapa den perfekta reseupplevelsen för dig, och vi vill hjälpa dig att välja rätt Interrail Pass som passar dina unika resebehov. Resande med tåg i Europa är mer än bara transport; det är en möjlighet att utforska kulturer, se fantastiska platser och skapa minnen som varar livet ut. Låt oss guida dig genom processen att välja det bästa Interrail Pass för dig, så att du kan börja din resa med förtroende, komfort och en smidig plan."
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(CustomPic, {
            picturePath: "pictures/champs_elysees.jpg",
            height: "12rem"
          }),
          _createVNode(TextBlock, { header: "Så väljer du rätt Interrail Pass för dina resebehov i Europa" }, {
            default: _withCtx(() => [
              _createTextVNode(" Vilket Pass du bör välja beror främst på vart du vill resa. Om du planerar att besöka ett enda land kan du välja ett \"One Countey\"-pass för det landet. Om du vill besöka flera länder är ett Global-pass (giltigt i 33 europeiska länder) det bästa alternativet. "),
              _hoisted_2,
              _hoisted_3,
              _createTextVNode(" För det andra bör du välja ett pass som matchar antalet dagar du planerar att använda det europeiska tågnätet. Dessa så kallade rese­dagar erbjuds i ett brett utbud, från endast 4 dagar upp till maximalt 3 månader. "),
              _hoisted_4,
              _hoisted_5,
              _createTextVNode(" För det tredje, om du letar efter lite mer komfort och lyx, är ett 1:a klass pass det rätta valet. Om du håller koll på din budget eller inte bryr dig så mycket om lyx är 2:a klass det mer prisvärda alternativet för att besöka alla de platser som finns på din önskelista. "),
              _hoisted_6,
              _hoisted_7,
              _createTextVNode(" Slutligen kan du välja att resa med ett mobilt Pass eller ett papperspass. Ett mobilt Pass erbjuder dig pappersfri resa, och du behöver inte vänta på leverans; vi skickar allt till dig via e-post. Detta gör det till ett utmärkt alternativ om du vill börja resa direkt. Om du vill resa med ett papperspass finns det att köpa hos den internationella organisationen Eurail. Leveranstiderna varierar per land för papperspasset, så se till att kontrollera den beräknade leveranstiden vid kassan. ")
            ]),
            _: 1
          }),
          _createVNode(TextBlock, { header: "Riktlinjer kring val av Interrail Pass" }, {
            default: _withCtx(() => [
              _createTextVNode(" För att hitta det Interrail-kort som passar dig och din resa, behöver du följa några enkla riktlinjer och ta hänsyn till dina specifika behov. Planering är nyckeln till en framgångsrik tågluff i Europa, och här är stegen du kan följa: "),
              _hoisted_8,
              _hoisted_9,
              _hoisted_10,
              _createTextVNode(" Börja med att skapa en resplan, eller en itinerary, där du listar de destinationer du vill besöka och hur många dagar du planerar att spendera på varje plats. "),
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createTextVNode(" Sök efter lämpliga tågförbindelser mellan dina destinationer. Ta hänsyn till avgångstider, restider, ankomsttider och om du kommer hinna utforska start- eller slutdestinationen samma dag som din tågresa. Du kan enkelt hitta passande tåg med hjälp av RailPlanner-appen. Vårt tips är att börja med att antingen spika första eller sista tågresan (beroende på vad som begränsar dig) och arbeta dig sedan sekventiellt genom hela din tågluff i Europa. "),
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _createTextVNode(" När din reseplan är klar kan du räkna ut hur lång din totala resa blir och hur många resdagar den kommer att omfatta. Använd vår guide "),
              _hoisted_17,
              _createTextVNode(" för att förstå vad en resdag innebär. Välj sedan det Interrail Pass som bäst uppfyller dina krav. Vi rekommenderar att du har lite extra utrymme för att kunna njuta av en extra resdag med tågresor eller extra tid på en destination. Det är alltid bra att undvika att riskera att ditt Interrail Pass tar slut innan du är tillbaka hemma. Kom ihåg att det kan vara dyrare att betala för resor på plats än att välja ett mer omfattande Interrail-kort från början. ")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})